module.exports = __webpack_public_path__ + "static/img/ai-recommendations-head-img.bdcc191.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vilocal/ai-recommendations-head-img.png
// module id = THQM
// module chunks = 2